export const appId = 5

export const appVersion = 1

export const appBasePath = process.env.NODE_ENV === 'production' ? 'https://yokradio.com' : 'https://yokradio.com'

export const gaTagId = process.env.NODE_ENV === 'production' ? 'UA-119806067-6' : 'UA-119806067-7'

export const fbAppId = process.env.NODE_ENV === 'production' ? '176257497885359' : '176257497885359'

export const fbPixelId = process.env.NODE_ENV === 'production' ? '568388307490038' : '568388307490038'

export const corsProxy = 'https://stark-cove-81248.herokuapp.com/'
